module.exports = __webpack_public_path__ + "static/media/arrow-right-md-dark.0127f52e.svg";